// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

// # Unprovisioned Homepage Card
// Children will typically be instance of './views/unprovisioned-info'

// ## Dependencies
import { MediaObject } from '@salesforce/design-system-react';

// ### React
import React from 'react';
import PropTypes from 'prop-types';

function CardSubHeader({ heading, icon, subHeader }) {
  const body = <h2 className="slds-text-heading--small slds-truncate">{heading}</h2>;

  return (
    <div className="slds-size--1-of-1">
      <MediaObject figure={icon} body={body} verticalCenter canTruncate />
      {subHeader}
    </div>
  );
}

// ### Display Name
CardSubHeader.displayName = 'CARD_SUB_HEADER';

// ### Prop Types
CardSubHeader.propTypes = {
  /**
   * The heading is the name of the related item group.
   */
  heading: PropTypes.string.isRequired,
  /**
   * Icon associated with the items within the `body`.
   */
  icon: PropTypes.node,
  /**
   * Sub header node to be rendered underneath the icon and heading.
   */
  subHeader: PropTypes.node,
};

export default CardSubHeader;
